module.exports = __webpack_public_path__ + "static/media/x-cloud.f26e4882.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProgressBar/assets/x-cloud.png
// module id = gCui
// module chunks = 23